import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: 'AIzaSyCGbu89fiyF3f-tbyTmkhD8nejPhYP1jKk',
    authDomain: 'fleetify-software.firebaseapp.com',
    projectId: 'fleetify-software',
    storageBucket: 'fleetify-software.firebasestorage.app',
    messagingSenderId: '431062086527',
    appId: '1:431062086527:web:78be4d4f1fce48b2ca604a',
    measurementId: 'G-BLR0YTH51E',
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const db = getFirestore(app);

export { app, db };
